import * as resultsStyles from '../../styles/actualites/news-guide.module.scss';
import PropTypes from 'prop-types';
import News from './News';
import EventOrNewsList from '../shared/EventOrNewsList';
import React from 'react';
import {filter} from 'lodash';

const Results = React.memo(function Results ({news, display, locale, getCategories}) {
  const filterCategories = (selectedCategories) => {
    const category = filter(selectedCategories, (elem) => elem.clicked);
    category[0].type = 'category';
    getCategories(category);
  };

  return (
    <div
      className={resultsStyles.resultContainer}
    >
      {news?.map((newsItem, index) => {
        const {publishedAt, categories, title, heading, cover, slug} = newsItem;
        if (display === 'GRID') {
          return (
            <div
              className={resultsStyles.resultColumnContainer}
              key={index}
            >
              <News
                categories={categories}
                cover={cover}
                getCategories={filterCategories}
                href={slug}
                locale={locale}
                preview={heading}
                title={title}
              >
              </News>
            </div>
          );
        }
        return (
          <div
            className={resultsStyles.resultListContainer}
            key={index}
          >
            <EventOrNewsList
              categories={categories}
              cover={cover}
              date={publishedAt}
              getCategories={filterCategories}
              href={slug}
              locale={locale}
              preview={heading}
              title={title}
            >
            </EventOrNewsList>
          </div>
        );
      })}
    </div>
  );
});

Results.propTypes = {
  display: PropTypes.oneOf(['GRID', 'LIST']).isRequired,
  getCategories: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  news: PropTypes.arrayOf(PropTypes.shape({
    publishedAt: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        clicked: PropTypes.bool,
      })
    ).isRequired,
    title: PropTypes.string.isRequired,
    heading: PropTypes.string,
    cover: PropTypes.shape({
      imageFile: PropTypes.object.isRequired,
      name: PropTypes.string,
    }).isRequired,
    slug: PropTypes.string.isRequired,
  })).isRequired,
};

export default Results;
